<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip right content-class="grey darken-4">
        <template v-slot:activator="{ on: tooltipEvents, attrs: tooltipAttrs }">
          <v-btn
            small
            icon
            color="primary"
            class="mx-1"
            :to="`/holdings/${item.houseFundId}?refDate=${item.refDate.substring(0, 10)}`"
            v-bind="tooltipAttrs"
            v-on="tooltipEvents"
          >
            <v-icon>
              mdi-magnify
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:default>
          Ver detalhes
        </template>
      </v-tooltip>
    </template>

    <template v-slot:item.refDate="{ item }">
      {{ formatDate(item.refDate) }}
    </template>

    <template v-slot:item.netValue="{ item }">
      {{ formatCurrency(item.netValue || item.calculatedNetValue) }}
    </template>

    <template v-slot:item.price="{ item }">
      {{ formatQuota(item.price || item.calculatedPrice) }}
    </template>
  </v-data-table>
</template>

<script>
import { formatDate, formatCurrency, formatNumber } from '@/utils/format-utils';

export default {
  name: 'HoldingsTable',

  inheritAttrs: false,

  data: () => ({
    headers: [
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
        groupable: false,
        align: 'center',
        width: '48px',
      },

      {
        text: 'Fundo',
        value: 'shortName',
      },

      {
        text: 'Data',
        value: 'refDate',
      },

      {
        text: 'Patrimônio Líquido',
        value: 'netValue',
        align: 'end',
      },

      {
        text: 'Cota Líquida',
        value: 'price',
        align: 'end',
      },
    ],
  }),

  methods: {
    formatDate,
    formatCurrency,
    formatNumber,
    formatQuota: (val) => formatCurrency(val, {
      minimumFractionDigits: 8,
      maximumFractionDigits: 8,
    }),
  },
};
</script>
